// 配置应用的AppKey
// 壹心理M站 key：be2579193b754fd2900f660a0093fa62
// 壹心理APP key：f6f19cec54894af8990714a597fc09f4
// 口袋心理APP：c6ef6a45ade340999081be514623f29e
// 壹心理学院（kc）：38193a7a6e34415daeef0cb2b0002e54
// 活动汇总项目（kc）：e989fdd0fb8b4af384ec7c87c2d9cfb4
// 咨询师之家: ad1f752ccbb84fc6bbb6a487692e4f8c
// 盘古系统: 6a435dc3efc14485a21a181eba7bf6fe

export default {
  msite: 'be2579193b754fd2900f660a0093fa62',
  yxlApp: 'f6f19cec54894af8990714a597fc09f4',
  cpApp: 'c6ef6a45ade340999081be514623f29e',
  kc: '38193a7a6e34415daeef0cb2b0002e54',
  yixinliPC: '18f5038ab49c4ae4918641ae36d67496',
  promotion: 'e989fdd0fb8b4af384ec7c87c2d9cfb4',
  homeOfConsultants: 'ad1f752ccbb84fc6bbb6a487692e4f8c',
  pg: '6a435dc3efc14485a21a181eba7bf6fe',
  cp: '954fc7ea2885479cae96792800783191'
}



// WEBPACK FOOTER //
// ./src/frontend-lib/lib/stat/zhugeIO_keys.js